import React, { FC } from 'react';
import GoogleAnalytics from 'utils/googleAnalytics/googleAnalytics';
import HeaderBase from './HeaderBase/HeaderBase';
import { NotLoggedInLogo } from './Logo/Logo';
import usePromoBanner from './hooks/usePromoBanner';
import { HeaderSignupButton, LogInButton } from './Button/Button';
import tracking from './Header.tracking';
import style from './Header.module.scss';

const LandingHeader: FC = () => {
    const promoBannerOptions = {
        isMobilePromotionEnabled: false,
    };
    const promoBanner = usePromoBanner(promoBannerOptions);

    const handleLogoClick = React.useCallback(() => {
        GoogleAnalytics.sendEvent(tracking.clickOnLogo);
    }, []);

    return (
        <HeaderBase
            banner={promoBanner}
            logo={<NotLoggedInLogo onClick={handleLogoClick} />}
            buttons={
                <>
                    <HeaderSignupButton />
                    <LogInButton />
                </>
            }
            className={style.landingHeaderBlock}
        />
    );
};

export default LandingHeader;
